/* AimControllers order panel for expel.gg /pages/controller.
   Spec: G:\Apps\AimCheckout\CONTRACT.md. Vanilla, no libraries.
   The buyer builds an order here (lines, versions, quantities, Aim's add-ons, prices with code EXPEL worked out from the catalog),
   then ONE WooCommerce checkout link opens AimControllers' own checkout with every line and code EXPEL: the US store
   (ref 480, USD) for the Americas, the EU store (ref 299, EUR) for everywhere else.
   Nothing is paid, typed or sent on expel.gg: no network requests, no storage, no cookies.
   Modes (data-mode on .aimco, from snippets/aim-checkout.liquid): on = Shop and EU buttons open the panel; off = the
   snippet renders nothing and the buttons stay plain links to Aim with Expel's ref. What the panel offers (ids, our
   names, prices, code EXPEL, the EU store's ids and prices) is the catalog JSON that snippets/aim-catalog.liquid
   renders inside the panel root (written by AimCheckout/tools/catalog.py); missing or bad = act as off. */
(function () {
  'use strict';
  var root = document.querySelector('.aimco');
  if (!root || !window.Element || !Element.prototype.closest || !Number.isSafeInteger) return;

  var AIM_US = 'https://us.aimcontrollers.com';
  var AIM_EU = 'https://eu.aimcontrollers.com';
  var LOCAL = /^(localhost|127\.0\.0\.1)$/.test(location.hostname);
  var MODE = root.getAttribute('data-mode');
  if (MODE === 'demo' || MODE === 'live') MODE = 'on';   // the old setting values (the snippet maps them too)
  if (MODE !== 'on') return;

  function digits(s, d) { return /^[0-9]{1,9}$/.test(s || '') ? s : d; }
  var CONFIG = {
    ref: digits(root.getAttribute('data-ref'), '480'),        // Expel's ref on the US store (links and checkout link)
    euRef: digits(root.getAttribute('data-eu-ref'), '299')    // Expel's ref on the EU store (product page links)
  };
  // Where the add-on pictures live: the store's Shopify Files folder (data-assets, from file_url in
  // snippets/aim-checkout.liquid; the file names are the catalog's `img`). Only a plain https, protocol-relative or
  // root-relative folder URL is used; anything else = no pictures (plain tiles), never a broken or odd URL.
  var FILES = (function (s) {
    return typeof s === 'string' && /^(?:(?:https:)?\/\/[a-z0-9.-]+(?::[0-9]{1,5})?)?\/(?:[A-Za-z0-9._~%-]+\/)*$/.test(s) ? s : '';
  })(root.getAttribute('data-assets'));
  // The systems a product can say it's for (catalog `fits`), as the buyer reads them
  var FIT = { ps5: 'PS5', xbox: 'Xbox', mh5: 'PC MH5', mhx: 'PC MHX' };
  // colour dots on an add-on's colour choices (his pick 2026-11-02); a label not listed gets no dot
  var DOTS = { black: '#111', red: '#d3202f' };

  var CAT = readCatalog();
  if (!CAT) return;

  var main = root.querySelector('.aimco-main');
  var panel = root.querySelector('.aimco-panel');
  var title = root.querySelector('#aimco-title');
  var body = root.querySelector('.aimco-body');
  if (!main || !panel || !title || !body) return;

  // ---------------------------------------------------------------------------------------------------------
  // Catalog. Products in the buyer's order of display; versions in catalog order (the first offered version is the
  // one a Shop button or "Add" puts in the order). A product with versions: [] is a simple product: its line id is
  // the parent id and its price sits on the product (price, regular). A product or version that fails validation is
  // dropped (the rest still work); no product left, or a bad code, = act as off (a wrong price is the worst outcome).
  function readCatalog() {
    var el = root.querySelector('#aimco-catalog'), c;
    try { c = JSON.parse(el ? el.textContent : ''); } catch (e) { return null; }
    if (!c || typeof c !== 'object' || !Array.isArray(c.products) || !validCode(c.code)) return null;
    var seen = {};
    // kind bundle was Aim's separate "Expel PS5 Accessory Bundle" (US 1184082 / EU 1458788), deleted by Aim 2026-10-21: an
    // older catalog that still lists it must never put that dead id in a checkout link. Bundles are versions now.
    c.products = c.products.filter(function (p) { return !obj(p) || p.kind !== 'bundle'; })
      .map(function (p) { return cleanProduct(p, seen); }).filter(Boolean);
    if (!c.products.length) return null;
    if (!c.kinds || typeof c.kinds !== 'object') c.kinds = {};
    if (!isId(c.maxQty)) c.maxQty = 10;
    return c;
  }
  function isId(n) { return typeof n === 'number' && Number.isSafeInteger(n) && n > 0; }
  function money(n) { return typeof n === 'number' && Number.isSafeInteger(n) && n >= 0; }   // minor units (cents)
  function str(s) { return typeof s === 'string' && s.length > 0; }
  function slugOk(s) { return typeof s === 'string' && /^[a-z0-9-]+$/.test(s); }
  function obj(o) { return !!o && typeof o === 'object' && !Array.isArray(o); }
  // The product as offered (its bad versions dropped), or null
  function cleanProduct(p, seen) {
    if (!obj(p) || !isId(p.parent) || !slugOk(p.slug) || !str(p.name) || !str(p.kind) ||
        !Array.isArray(p.versions) || seen[p.parent] || seen['s:' + p.slug]) return null;
    // euSlug: the product's slug on Aim's EU store (Xbox's differs from the US one); optional, the US slug otherwise
    if (p.euSlug != null && !slugOk(p.euSlug)) return null;
    if (!p.versions.length) {
      if (!money(p.price) || (p.regular != null && !money(p.regular))) return null;
    } else {
      var had = p.versions.length;
      p.versions = p.versions.filter(function (v) {
        if (!obj(v) || !isId(v.id) || seen[v.id] || v.id === p.parent || !str(v.label) ||
            !money(v.price) || (v.regular != null && !money(v.regular))) return false;
        seen[v.id] = true;
        v.short = str(v.short) ? v.short : '';   // its name on the line's choice buttons ("Pro+"); the label otherwise
        // A bundle version (Aim's "Pro+ Bundle" / "Pro X Bundle", 2026-10-21): an ordinary version with what's in it
        // (contents), shown in a small box under its line. It takes code EXPEL by its own rule (code.rules[version id]).
        v.bundle = v.bundle === true;
        v.contents = v.bundle && str(v.contents) ? v.contents : '';
        return true;
      });
      if (had && !p.versions.length) return null;
    }
    // img: a file name in the Files folder (add-ons); fits: the systems it's made for, all known, else none
    p.img = typeof p.img === 'string' && /^[a-z0-9][a-z0-9-]*\.(?:webp|png|jpg)$/.test(p.img) ? p.img : '';
    p.fits = Array.isArray(p.fits) && p.fits.every(function (s) { return typeof s === 'string' && Object.prototype.hasOwnProperty.call(FIT, s); }) ?
      p.fits.filter(function (s, i, a) { return a.indexOf(s) === i; }) : [];
    // buttonOnly (the Expel Snap Panel, his ask 2026-10-25): sold only from its own buttons on the page, never offered
    // in the Add-ons strip or Add more. note: one short line under its name on its line (Aim's fit rule).
    p.buttonOnly = p.buttonOnly === true;
    p.note = str(p.note) && p.note.length <= 120 ? p.note : '';
    seen[p.parent] = seen['s:' + p.slug] = true;
    return p;
  }
  // Code EXPEL (catalog `code`, kept equal to Aim's US cart by tools/price_watch.py; `eu.code` for the EU store):
  // name, minSpend, rules keyed by a US parent id or a US version id (a version's own rule wins: the bundle versions,
  // 2026-10-21). A key that isn't an id, or a rule of an unknown shape, = a bad code (act as off).
  function validCode(k) {
    if (!obj(k) || typeof k.name !== 'string' || !/^[A-Za-z0-9_-]{1,40}$/.test(k.name) ||
        !money(k.minSpend) || !obj(k.rules)) return false;
    return Object.keys(k.rules).every(function (id) {
      var r = k.rules[id];
      return isId(Number(id)) && String(Number(id)) === id && obj(r) && ((r.kind === 'price_to' && money(r.value)) ||
        (r.kind === 'percent' && typeof r.value === 'number' && isFinite(r.value) && r.value > 0 && r.value <= 100));
    });
  }
  // Aim's US import duties (catalog `duties`, kept equal to Aim's US cart by tools/price_watch.py; his call 2026-10-30
  // "Show the amount"): percent % of the order's items after code EXPEL (add-ons included, no delivery), half-up to the
  // cent, + flatCents. A missing or bad block = no duties line. The EU store has none.
  function readDuties(d) {
    return obj(d) && d.base === 'items_after_discount' && isId(d.percent) && d.percent <= 30 && money(d.flatCents) ?
      { percent: d.percent, flat: d.flatCents } : null;
  }
  // BY_SLUG: slug -> product; BY_EU: EU slug (or US slug) -> product; BY_ID: line id (variation id, or a simple
  // product's parent id) -> {p, v (null if simple)}
  var BY_SLUG = {}, BY_EU = {}, BY_ID = {};
  function indexCatalog() {
    BY_SLUG = {}; BY_EU = {}; BY_ID = {};
    CAT.products.forEach(function (p) {
      BY_SLUG[p.slug] = p;
      BY_EU[p.euSlug || p.slug] = p;
      if (p.versions.length) p.versions.forEach(function (v) { BY_ID[v.id] = { p: p, v: v }; });
      else BY_ID[p.parent] = { p: p, v: null };
    });
  }
  indexCatalog();
  function lineIds(p) { return p.versions.length ? p.versions.map(function (v) { return v.id; }) : [p.parent]; }
  // "<name> · <label>" (just the name for a simple product): our names, everywhere the buyer looks
  function lineName(id) {
    var e = BY_ID[id];
    return e ? e.p.name + (e.v ? ' \u00b7 ' + e.v.label : '') : '';
  }
  // What a line id is sold as in the US store: the version, or the simple product itself (price, regular, soldOut)
  function item(id) { var e = BY_ID[id]; return e ? e.v || e.p : null; }

  // ---------------------------------------------------------------------------------------------------------
  // The EU store (CONTRACT "Two stores: US and EU"): catalog `eu` = {ref, currency, code, products: {"<US parent>":
  // {parent: <EU parent>, versions: {"<US line id>": {id: <EU id>, price, regular}}}}}. The order stays keyed by US
  // ids; only the EU prices and link use these. A bad entry is dropped; a missing or bad block = no EU store (no
  // switch, the EU buttons stay links). A simple product maps under versions by its US parent id.
  var EU = readEu(CAT.eu);
  function readEu(e) {
    if (!obj(e) || !validCode(e.code) || (e.currency != null && e.currency !== 'EUR') || !obj(e.products)) return null;
    var byId = {}, seen = {}, n = 0;
    Object.keys(e.products).forEach(function (usParent) {
      var x = e.products[usParent];
      if (!obj(x) || !isId(x.parent) || !obj(x.versions) || seen['p' + x.parent]) return;
      seen['p' + x.parent] = true;
      Object.keys(x.versions).forEach(function (usId) {
        var v = x.versions[usId], id = Number(usId);
        if (!isId(id) || String(id) !== usId || byId[id] || !obj(v) || !isId(v.id) || seen[v.id] || !money(v.price) ||
            (v.regular != null && !money(v.regular))) return;
        seen[v.id] = true;
        // contents: a bundle's own list on the EU store (it differs from the US one)
        byId[id] = { usParent: Number(usParent), id: v.id, price: v.price, regular: money(v.regular) ? v.regular : v.price, soldOut: v.soldOut === true,
                     contents: str(v.contents) ? v.contents : '' };
        n += 1;
      });
    });
    return n ? { ref: isId(e.ref) ? String(e.ref) : CONFIG.euRef, code: e.code, byId: byId } : null;
  }

  // Each store: where the link goes, its ref and code, and a line's entry there ({id, price, regular, soldOut} or null
  // when that store doesn't sell it). US soldOut comes from the daily US price check; an EU entry can carry its own.
  var STORES = {
    us: { name: 'us', base: AIM_US, ref: CONFIG.ref, code: CAT.code, go: 'Check out on AimControllers', duties: readDuties(CAT.duties),
          entry: function (id) {
            var it = item(id);
            return it ? { id: id, price: it.price, regular: money(it.regular) ? it.regular : it.price, soldOut: it.soldOut === true } : null;
          },
          page: function (p) { return AIM_US + '/product/' + p.slug + '/ref/' + CONFIG.ref + '/'; } },
    eu: EU ? { name: 'eu', base: AIM_EU, ref: EU.ref, code: EU.code, go: 'Check out on AimControllers EU', duties: null,
               entry: function (id) {
                 var x = EU.byId[id];
                 return x && BY_ID[id] && BY_ID[id].p.parent === x.usParent ? x : null;
               },
               page: function (p) { return AIM_EU + '/product/' + (p.euSlug || p.slug) + '/ref/' + CONFIG.euRef + '/'; } } : null
  };
  function storeOf(name) { return name === 'eu' && STORES.eu ? STORES.eu : STORES.us; }

  // The Americas test, copied from the page's time-zone swap (tools/dyn/EController.py, CONTRACT "Regions") so the
  // panel's default store and the red button agree. Keep the two identical. Only the browser's own time-zone setting
  // is read: no network call, nothing stored.
  function inAmericas() {
    var tz = '';
    try { tz = String(Intl.DateTimeFormat().resolvedOptions().timeZone || ''); } catch (e) { tz = ''; }
    if (/^(localhost|127\.0\.0\.1)$/.test(location.hostname)) {  // tests only: ?tz=Europe/Berlin
      var q = location.search.match(/[?&]tz=([^&#]*)/);
      if (q) { try { tz = decodeURIComponent(q[1]); } catch (e) {} }
    }
    return !tz || /^(America|US|Canada|Brazil|Chile|Mexico|Etc)\//.test(tz) ||
      /^(Pacific\/(Honolulu|Galapagos|Easter)|Atlantic\/(Bermuda|Stanley|South_Georgia)|UTC|GMT)$/.test(tz);
  }

  // ---------------------------------------------------------------------------------------------------------
  // Prices with code EXPEL (CONTRACT "Prices with code EXPEL"): worked out from the catalog with the rules Aim's cart
  // showed. lines: [[id, qty], ...] (US line ids); store: 'us' (default) or 'eu'. Every amount in the store's minor
  // units. Lines the store doesn't sell (or that aren't in the catalog) are left out. total = items after the code;
  // duties = the store's import duties on it (US only, 0 without a duties block); due = total + duties (shown as the total).
  function estimate(lines, store) {
    var st = store === 'eu' ? STORES.eu : STORES.us, rows = [], subtotal = 0, discount = 0;
    if (!st) return { subtotal: 0, discount: 0, total: 0, duties: 0, due: 0, applies: false, lines: [] };   // no EU store in the catalog
    (Array.isArray(lines) ? lines : []).forEach(function (x) {
      var id = x && x[0], qty = x && x[1], en = isId(id) && isId(qty) ? st.entry(id) : null;
      if (!en) return;
      rows.push({ id: id, qty: qty, price: en.price, parent: BY_ID[id].p.parent, before: en.price * qty });
      subtotal += en.price * qty;
    });
    var code = st.code, applies = subtotal >= code.minSpend;
    rows.forEach(function (r) {
      var rule = applies ? ruleFor(code, r.id, r.parent) : null, d = 0;
      if (rule && rule.kind === 'price_to') d = Math.max(0, r.price - rule.value) * r.qty;   // each unit ends at value
      else if (rule && rule.kind === 'percent') d = Math.floor((r.before * rule.value + 50) / 100 + 1e-9);   // half-up, per line
      d = Math.min(d, r.before);
      r.after = r.before - d;
      discount += d;
    });
    var total = subtotal - discount, duties = st.duties && subtotal > 0 ? Math.floor((total * st.duties.percent + 50) / 100) + st.duties.flat : 0;
    return { subtotal: subtotal, discount: discount, total: total, duties: duties, due: total + duties, applies: applies,
             lines: rows.map(function (r) { return { id: r.id, qty: r.qty, before: r.before, after: r.after }; }) };
  }
  // A line's rule: its own version's (rules["<US version id>"], the bundle versions since 2026-10-21) if there is one,
  // else its product's (rules["<US parent>"]), else none (no discount)
  function ruleFor(code, id, parent) {
    var has = function (k) { return Object.prototype.hasOwnProperty.call(code.rules, String(k)); };
    return has(id) ? code.rules[id] : has(parent) ? code.rules[parent] : null;
  }
  // The one WooCommerce checkout link (CONTRACT "The checkout link"): every line the store sells as <store id>:<qty>
  // in order, the code only when it takes something off, the store's ref always. Ids and quantities are positive
  // integers from the catalog only; nothing the buyer typed ever goes in. '' when nothing is left to buy.
  function checkoutUrl(lines, store) {
    var st = store === 'eu' ? STORES.eu : STORES.us;
    if (!st) return '';
    var ok = (Array.isArray(lines) ? lines : []).filter(function (x) { return x && isId(x[0]) && isId(x[1]) && st.entry(x[0]); });
    if (!ok.length) return '';
    var u = st.base + '/checkout-link/?products=' + ok.map(function (x) { return st.entry(x[0]).id + ':' + x[1]; }).join(',');
    if (estimate(ok, st.name).discount > 0) u += '&coupon=' + encodeURIComponent(st.code.name);
    return u + '&ref=' + st.ref;
  }

  // ---------------------------------------------------------------------------------------------------------
  // Panel state. The order and its store live in page memory only (never storage): they survive closing the panel
  // and clear on reload. Clicking the checkout link keeps them.
  var S = { lines: [], slug: null, more: false, notice: '', soldSlug: null, store: STORES.eu && !inAmericas() ? 'eu' : 'us' };
  root.setAttribute('data-store', S.store);
  var opener = null, closeTimer = null, EUR = null;
  var IMG_KEY = { ps5: 'ps5', xbox: 'xbox', mh5: 'pcps5', mhx: 'pcxbox' };   // catalog system -> the page's .r-ed card
  // The panel's links out to AimControllers (the checkout link, a sold-out product's page)
  var LEAVE = 'a[data-fk="go"], a[data-aimco-soldlink]';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  // Money in the store's currency: $1,234.00 (US), €1,234.00 (EU, en-IE)
  function fmt(minor, st) {
    var n = Number(minor) / 100;
    if (st && st.name === 'eu') {
      try { EUR = EUR || new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR' }); return EUR.format(n); }
      catch (e) { return '\u20ac' + n.toFixed(2); }
    }
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function cur() { return storeOf(S.store); }

  // ---- the order -------------------------------------------------------------------------------------------
  // Can this line id go in the order in the current store? (sold there, not sold out there)
  function okId(id) { var en = cur().entry(id); return !!en && en.soldOut !== true; }
  function lineOf(id) { return S.lines.filter(function (l) { return l.id === id; })[0] || null; }
  function hasProduct(p) { var ids = lineIds(p); return S.lines.some(function (l) { return ids.indexOf(l.id) >= 0; }); }
  // The product's first offered version the store sells, not sold out and not already a line (null = none left)
  function firstFree(p) {
    return lineIds(p).filter(function (id) { return okId(id) && !lineOf(id); })[0] || null;
  }
  function capFor() { return CAT.maxQty; }
  // The order as [[id, qty], ...] in line order (a bundle version is a line like any other)
  function orderPairs() {
    return S.lines.map(function (l) { return [l.id, l.qty]; });
  }
  function clearNotice() { S.notice = ''; S.soldSlug = null; }
  function setStore(name) {
    S.store = storeOf(name).name;
    root.setAttribute('data-store', S.store);
  }
  function addLine(id) {
    S.lines.push({ id: id, qty: 1 });
    S.slug = BY_ID[id].p.slug;
    clearNotice();
  }
  // A Shop (or EU) button: add its product's first offered version, unless the product already has a line.
  function shopAdd(slug) {
    var p = BY_SLUG[slug];
    S.slug = slug;
    if (hasProduct(p)) return;
    var id = firstFree(p);
    if (id) { addLine(id); return; }
    S.notice = p.name + ' is sold out here right now. AimControllers\' own store may have it back sooner.';
    S.soldSlug = slug;
  }
  function setQty(i, qty) {
    var l = S.lines[i];
    if (!l) return;
    qty = Math.max(1, Math.min(capFor(l.id), qty));
    if (qty === l.qty) return;
    l.qty = qty;
    clearNotice();
  }
  function removeLine(i) {
    if (!S.lines[i]) return;
    S.lines.splice(i, 1);
    clearNotice();
  }
  // Another version on a line; when another line already has it the two merge (quantities add, capped at maxQty).
  function setVersion(i, id) {
    var l = S.lines[i];
    if (!l || l.id === id || !BY_ID[id] || BY_ID[id].p !== BY_ID[l.id].p || !okId(id)) return;
    var other = lineOf(id);
    if (other) {
      l.qty += other.qty;
      S.lines.splice(S.lines.indexOf(other), 1);
    }
    l.qty = Math.max(1, Math.min(capFor(id), l.qty));
    l.id = id;
    clearNotice();
  }
  // A choice button on a line (his ask 2026-10-20): one of the product's versions ("Pro+" | "Pro+ Bundle", "Black" |
  // "Red"). The buyer still clicks Check out.
  function pick(i, id) { setVersion(i, id); }
  // A line's version sold out (the catalog says so): it comes off the order with a notice.
  function soldOut(id) {
    var l = lineOf(id);
    if (!l) return;
    var name = lineName(id), p = BY_ID[id].p;
    S.lines.splice(S.lines.indexOf(l), 1);
    S.notice = name + ' just sold out, so it came off your order. Pick another version, or check AimControllers\' own store.';
    S.soldSlug = p.slug;
  }

  // ---- rendering ------------------------------------------------------------------------------------------
  function isOpen() { return !root.hidden && root.classList.contains('is-open'); }
  // After main is re-rendered the focused element may be gone (focus falls to <body>): put it on the heading, so Esc
  // and the Tab trap keep working.
  function keepFocus() {
    if (!isOpen()) return;
    var a = document.activeElement;
    if (a && a !== document.body && panel.contains(a)) return;
    title.focus({ preventScroll: true });
  }
  // Re-render main and keep focus on the same control (data-fk) when it's still there and can take focus.
  function paint(html) {
    var a = document.activeElement, fk = a && main.contains(a) ? a.getAttribute('data-fk') : null;
    main.innerHTML = html;
    if (fk && isOpen()) {
      var n = main.querySelector('[data-fk="' + fk + '"]');
      if (n && !n.disabled) { n.focus({ preventScroll: true }); if (document.activeElement === n) return; }
    }
    keepFocus();
  }
  // A product's picture: an add-on's from the Files folder (catalog img), a controller's from its card on the page;
  // '' = none (a plain tile). A picture that failed to load once isn't asked for again (BROKEN).
  var BROKEN = {};
  function imgFor(p) {
    if (p.img) return FILES && !BROKEN[FILES + p.img] ? FILES + p.img : '';
    var k = IMG_KEY[p.system], img = k && document.querySelector('.r-ed[data-k="' + k + '"] .r-ed-pad');
    return img && img.getAttribute('src') && !BROKEN[img.getAttribute('src')] ? img.getAttribute('src') : '';
  }
  function orList(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' or ' + a[a.length - 1]; }
  function andList(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' & ' + a[a.length - 1]; }
  function arrow() { return '<span aria-hidden="true">\u2197</span>'; }

  // A line's price: with the code, the line after it big and the line before it struck; without, price x qty (and
  // regular x qty struck when on sale). A line the EU store doesn't sell says so.
  function linePriceHtml(id, el, st) {
    if (!el) return '<span class="aimco-nosale">Not sold by the EU store</span>';
    if (el.after < el.before) {
      return '<s class="aimco-was"><span class="aimco-vh">Without the code </span>' + esc(fmt(el.before, st)) + '</s> <span class="aimco-price">' + esc(fmt(el.after, st)) + '</span>';
    }
    var reg = st.entry(id).regular * el.qty;
    return (reg > el.before ? '<s class="aimco-was"><span class="aimco-vh">Was </span>' + esc(fmt(reg, st)) + '</s> ' : '') + '<span class="aimco-price">' + esc(fmt(el.before, st)) + '</span>';
  }
  // A line's choices (his ask 2026-10-20, buttons instead of a picker): one button per offered version, its short name
  // or label ("Pro+" | "Pro+ Bundle", "Pro X" | "Pro X Bundle", "Black" | "Red"). A version the store can't sell now
  // shows disabled with why. One choice = no buttons, just the label.
  function choicesHtml(l, i, st) {
    var p = BY_ID[l.id].p;
    if (p.versions.length < 2) return '';
    // An add-on's choices (paddle colours) are round colour pills, so they never look like Pro+ | Pro+ Bundle (his pick
    // 2026-11-02, option 3 "Light touch").
    var sw = p.kind === 'addon';
    return '<div class="aimco-pick' + (sw ? ' aimco-sw' : '') + '" role="group" aria-label="Choose ' + esc(p.name) + '">' + p.versions.map(function (v, k) {
      var ok = okId(v.id) || v.id === l.id, why = st.entry(v.id) ? 'Sold out' : 'Not sold by the EU store';
      var dot = sw ? DOTS[String(v.label || '').toLowerCase()] : '';
      return '<button type="button" data-act="pick" data-i="' + i + '" data-v="' + esc(v.id) + '" data-fk="pick-' + i + '-' + k + '"' +
        ' aria-pressed="' + (v.id === l.id) + '"' + (ok ? '' : ' disabled') + '>' + (dot ? '<i class="aimco-dot" style="background:' + dot + '" aria-hidden="true"></i>' : '') + esc(v.short || v.label) +
        (ok ? '' : '<span class="aimco-pick-why"> \u00b7 ' + esc(why) + '</span>') + '</button>';
    }).join('') + '</div>';
  }
  // A bundle version's box under its line: "In the bundle box" and a check list of what's in it (the EU entry's own list
  // in the EU store when it has one; his pick 2026-11-02, option 3). No price here: the line's own price is the bundle's.
  function bundleHtml(l, st) {
    var e = BY_ID[l.id], en = st.entry(l.id);
    if (!e.v || !e.v.bundle) return '';
    var contents = (en && en.contents) || e.v.contents;
    var items = String(contents || '').split(/,\s*|\s+and\s+/).map(function (s) { s = s.trim(); return s.charAt(0).toUpperCase() + s.slice(1); }).filter(Boolean);
    return '<div class="aimco-bx"><b>In the bundle box</b>' + (items.length ? '<ul class="aimco-kit">' + items.map(function (s) {
      return '<li><svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="M3 8.5l3 3 7-7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' + esc(s) + '</li>';
    }).join('') + '</ul>' : '') + '</div>';
  }
  // An add-on line's tag: it's its own item, not part of a bundle (his pick 2026-11-02). Not on the Snap Panel (bought alone).
  function extraTag(p) {
    return p.kind === 'addon' && !p.buttonOnly ? '<span class="aimco-xtag">Extra · sold separately · full price</span>' : '';
  }
  function lineHtml(l, i, el, st) {
    var e = BY_ID[l.id], p = e.p, src = imgFor(p), cap = capFor(l.id);
    var name = lineName(l.id), ch = choicesHtml(l, i, st), pick = extraTag(p) + ch, bx = bundleHtml(l, st);
    var ver = !ch && e.v ? '<span class="aimco-ln-v">' + esc(e.v.label) + '</span>' : '';
    return '<li class="aimco-ln' + (pick || bx ? ' has-c' : '') + '" data-line="' + esc(l.id) + '">' +
      (src ? '<img src="' + esc(src) + '" alt="" width="64" height="48"' + (p.kind === 'addon' ? ' class="aimco-ln-x"' : '') + '>' : '<span class="aimco-ln-img" aria-hidden="true"></span>') +
      '<div class="aimco-ln-t"><b>' + esc(p.name) + '</b>' + ver + (p.note ? '<span class="aimco-ln-v aimco-ln-note">' + esc(p.note) + '</span>' : '') + '</div>' +
      '<div class="aimco-ln-p">' + linePriceHtml(l.id, el, st) + '</div>' +
      (pick || bx ? '<div class="aimco-ln-c">' + pick + bx + '</div>' : '') +
      '<div class="aimco-ln-q"><div class="aimco-qty" role="group" aria-label="Quantity of ' + esc(name) + '">' +
      '<button type="button" data-act="dec" data-i="' + i + '" data-fk="dec-' + i + '" aria-label="One fewer"' + (l.qty <= 1 ? ' disabled' : '') + '>&minus;</button>' +
      '<output aria-live="polite">' + esc(l.qty) + '</output>' +
      '<button type="button" data-act="inc" data-i="' + i + '" data-fk="inc-' + i + '" aria-label="One more"' + (l.qty >= cap ? ' disabled' : '') + '>+</button></div>' +
      '<button type="button" class="aimco-link aimco-rm" data-act="remove" data-i="' + i + '" data-fk="rm-' + i + '">Remove<span class="aimco-vh"> ' + esc(name) + '</span></button></div></li>';
  }
  // "Add more": the catalog's products grouped by kind (empty groups hidden). "Add" puts in the first offered version
  // that isn't a line yet; with every version in the order it reads "In your order". In the EU store, versions it
  // doesn't sell are skipped (a product with none isn't listed). Add-ons aren't here: they have their own strip.
  function moreHtml(st) {
    var open = S.more || !S.lines.length;
    var h = '<div class="aimco-more"><button type="button" class="aimco-morebtn" data-act="more" data-fk="more" aria-expanded="' + open + '" aria-controls="aimco-addlist">Add more</button>';
    if (!open) return h + '</div>';
    var kinds = Object.keys(CAT.kinds);
    CAT.products.forEach(function (p) { if (kinds.indexOf(p.kind) < 0) kinds.push(p.kind); });
    kinds = kinds.filter(function (k) { return k !== 'addon'; });
    h += '<div class="aimco-addlist" id="aimco-addlist">';
    kinds.forEach(function (k) {
      var ps = CAT.products.filter(function (p) { return p.kind === k && !p.buttonOnly && lineIds(p).some(function (id) { return st.entry(id); }); });
      if (!ps.length) return;
      h += '<div class="aimco-kind"><p class="aimco-kind-t">' + esc(CAT.kinds[k] || k) + '</p><ul>';
      ps.forEach(function (p) {
        var src = imgFor(p), any = lineIds(p).some(okId), free = firstFree(p);
        var labels = p.versions.filter(function (v) { return st.entry(v.id); }).map(function (v) { return v.label; });
        h += '<li class="aimco-addrow">' + (src ? '<img src="' + esc(src) + '" alt="" width="56" height="42">' : '<span class="aimco-ln-img" aria-hidden="true"></span>') +
          '<span><b>' + esc(p.name) + '</b>' + (labels.length ? '<small>' + esc(orList(labels)) + '</small>' : '') + '</span>';
        if (!any) h += '<a class="aimco-link" href="' + esc(st.page(p)) + '" data-aimco-soldlink>Sold out here<span class="aimco-vh">: ' + esc(p.name) + ' on AimControllers\' store</span></a>';
        else if (free) h += '<button type="button" class="r-btn line sm aimco-add" data-act="add" data-parent="' + esc(p.parent) + '" data-fk="add-' + esc(p.parent) + '">Add<span class="aimco-vh"> ' + esc(p.name) + '</span></button>';
        else h += '<button type="button" class="r-btn line sm aimco-add" disabled>In your order</button>';
        h += '</li>';
      });
      h += '</ul></div>';
    });
    return h + '</div></div>';
  }
  // "Add-ons" (catalog kind addon: Aim's paddles and cases), between the lines and Add more, on an empty order too.
  // One row per add-on that still has a version to add in this store (firstFree), shaped like Add more's rows (his ask
  // 2026-10-20): small picture tile, name over "versions left · what it's for · price" (catalog fits, never a claim
  // about the buyer's own controller), Add. Add-ons for
  // a system that has a controller line come first, then the rest, catalog order within each. No cards = no strip. A
  // buttonOnly add-on (the Expel Snap Panel: the same design as the Expel PS5) is never offered here.
  function addonsHtml(st) {
    var sys = {};
    S.lines.forEach(function (l) { var p = BY_ID[l.id] && BY_ID[l.id].p; if (p && p.kind === 'controller' && p.system) sys[p.system] = true; });
    var ps = CAT.products.filter(function (p) { return p.kind === 'addon' && !p.buttonOnly && firstFree(p); });
    var fit = ps.filter(function (p) { return p.fits.some(function (s) { return sys[s]; }); });
    ps = fit.concat(ps.filter(function (p) { return fit.indexOf(p) < 0; }));
    if (!ps.length) return '';
    // Heading and line: his pick 2026-11-02 (option 3), so add-ons never read as part of a bundle.
    var h = '<section class="aimco-xtra" aria-labelledby="aimco-xtra-t"><div class="aimco-xtra-h"><h3 id="aimco-xtra-t">Extras, sold separately</h3>' +
      '<p>Separate items, not part of any bundle. Full price: code ' + esc(st.code.name) + ' doesn\'t apply.</p></div><ul class="aimco-xgrid">';
    ps.forEach(function (p) {
      var id = firstFree(p), en = st.entry(id), src = imgFor(p);
      var left = p.versions.filter(function (v) { return okId(v.id) && !lineOf(v.id); }).map(function (v) { return v.label; });
      var fits = p.fits.map(function (s) { return FIT[s]; });
      h += '<li class="aimco-xcard" data-parent="' + esc(p.parent) + '"><div class="aimco-xtile">' + (src ? '<img src="' + esc(src) + '" alt="" width="640" height="480" decoding="async">' : '') + '</div>' +
        '<div class="aimco-xinfo"><b>' + esc(p.name) + '</b><small class="aimco-xmeta">' + (left.length ? '<span class="aimco-xver">' + esc(orList(left)) + '</span>' : '') +
        (fits.length ? '<span class="aimco-xfit">For ' + esc(andList(fits)) + '</span>' : '') +
        '<span class="aimco-xprice">' + (en.regular > en.price ? '<s class="aimco-was"><span class="aimco-vh">Was </span>' + esc(fmt(en.regular, st)) + '</s> ' : '') + esc(fmt(en.price, st)) + '</span></small></div>' +
        '<button type="button" class="r-btn line sm aimco-xadd" data-act="addon-add" data-fk="addon-add" data-id="' + esc(id) + '" aria-label="Add ' + esc(p.name) + '">Add</button></li>';
    });
    return h + '</ul></section>';
  }
  // Ships from: the two stores (only when the catalog has a good EU block)
  function storeHtml() {
    if (!STORES.eu) return '';
    var b = function (name, label) {
      return '<button type="button" data-store="' + name + '" data-fk="store-' + name + '" aria-pressed="' + (S.store === name) + '">' + label + '</button>';
    };
    return '<div class="aimco-store" role="group" aria-label="Ships from">' + b('us', 'Americas') + b('eu', 'Europe &amp; rest of world') + '</div>';
  }
  function renderOrder() {
    var st = cur(), n = S.lines.length, pairs = orderPairs(), est = estimate(pairs, st.name), url = checkoutUrl(pairs, st.name), by = {};
    est.lines.forEach(function (x) { by[x.id] = x; });
    root.setAttribute('data-store', st.name);
    var h = storeHtml();
    if (S.notice) {
      h += '<p class="aimco-alert" role="alert">' + esc(S.notice) +
        (S.soldSlug && BY_SLUG[S.soldSlug] ? ' <a href="' + esc(st.page(BY_SLUG[S.soldSlug])) + '" data-aimco-soldlink>Check AimControllers\' store</a>' : '') + '</p>';
    }
    if (!n) h += '<p class="aimco-empty">Your order is empty.</p>';
    else h += '<ul class="aimco-lines">' + S.lines.map(function (l, i) { return lineHtml(l, i, by[l.id], st); }).join('') + '</ul>';
    h += addonsHtml(st);
    h += moreHtml(st);
    h += '<div class="aimco-sum" aria-live="polite">' +
      (est.discount > 0 ? '<div data-sum="code"><span>Code ' + esc(st.code.name) + '</span><span class="aimco-amt">\u2212' + esc(fmt(est.discount, st)) + '</span></div>' : '') +
      (est.duties > 0 ? '<div data-sum="duties"><span>Import duties (Aim adds at checkout)</span><span class="aimco-amt">' + esc(fmt(est.duties, st)) + '</span></div>' : '') +
      '<div data-sum="total" class="aimco-tot"><span>' + (st.name === 'eu' ? 'Total before delivery' : 'Total before delivery and tax') + '</span><span class="aimco-amt">' + esc(fmt(est.due, st)) + '</span></div></div>';
    // The code note: "applied" only when the link carries the coupon (discount > 0, the same estimate checkoutUrl uses);
    // add-ons never get anything off (Aim's cart, 2026-10-19), so say so; the bundle versions take the code like controllers
    // A buttonOnly add-on (the Expel Snap Panel) is named: the buyer never saw it called an add-on
    var xps = est.lines.map(function (x) { return BY_ID[x.id].p; }).filter(function (p) { return p.kind === 'addon'; });
    var own = xps.filter(function (p, i) { return p.buttonOnly && xps.indexOf(p) === i; }).map(function (p) { return p.name; });
    var plain = xps.some(function (p) { return !p.buttonOnly; });
    var full = plain ? ' Add-ons stay full price.' : own.length ? ' The ' + andList(own) + (own.length > 1 ? ' stay' : ' stays') + ' full price.' : '';
    if (est.discount > 0) h += '<p class="aimco-codenote" data-note="code">Code ' + esc(st.code.name) + ' is applied for you at AimControllers\' checkout.' + esc(full) + '</p>';
    else if (xps.length && xps.length === est.lines.length) h += '<p class="aimco-codenote" data-note="full">Code ' + esc(st.code.name) + ' only takes money off controllers, so ' +
      (plain ? 'add-ons are' : 'the ' + esc(andList(own)) + (own.length > 1 ? ' are' : ' is')) + ' full price.</p>';
    h += '<a class="r-btn red aimco-go" data-fk="go"' + (url ? ' href="' + esc(url) + '"' : ' role="link" aria-disabled="true"') + ' target="_blank" rel="noopener">' +
      esc(st.go) + ' ' + arrow() + '<span class="aimco-vh"> (opens in a new tab)</span></a>';
    h += '<p class="aimco-small">' + esc(shipNote(st, est)) + '</p>';
    paint(h);
  }
  // Delivery, tax and customs under the button, for the store picked (his ask 2026-11-02). Facts: Aim's carts (US FedEx
  // Standard from the catalog's delivery block, which price_watch checks daily) and Aim's terms (buyers outside the US /
  // the EU pay their own customs duties and local tax; EU prices include VAT). The US import-duties fee is the row above.
  function shipNote(st, est) {
    var d = CAT.delivery, r = d && Array.isArray(d.rates) && d.rates.filter(function (x) { return x && x.default; })[0];
    var one = r && Array.isArray(r.byQty) && money(r.byQty[0]) ? r.byQty[0] : 0;
    var ctl = est.lines.some(function (x) { var p = BY_ID[x.id] && BY_ID[x.id].p; return p && p.kind === 'controller'; });
    var tail = ' Checking out replaces anything already in your AimControllers cart.';
    if (st.name === 'eu') return 'Prices include VAT. Delivery isn\'t included: AimControllers adds it at checkout and shows your final total. ' +
      'Outside the EU, your country may charge customs and tax when it arrives.' + tail;
    return 'Delivery isn\'t included: AimControllers adds it at checkout' + (ctl && one ? ' (FedEx from ' + fmt(one, st) + ' for one controller to a US address)' : '') +
      ', with any tax, and shows your final total. Outside the US, your country may charge customs and tax when it arrives.' + tail;
  }
  function refresh() { if (!root.hidden) renderOrder(); }

  // ---- open / close / focus -------------------------------------------------------------------------------
  function focusables(scope) {
    return Array.prototype.filter.call(scope.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea,[tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }
  // A Shop button (US store) or EU button (EU store): open on Your order in that store and add its controller (first
  // offered version) unless that product already has a line; then it just opens. A sold-out product shows a notice
  // with a link to Aim's page. store: 'us' / 'eu', or leave the current one.
  function open(slug, from, store) {
    if (!BY_SLUG[slug]) return false;
    clearTimeout(closeTimer);
    if (!isOpen()) opener = from || document.activeElement;
    if (store) setStore(store);
    root.hidden = false;
    document.documentElement.classList.add('aimco-lock');
    void root.offsetWidth;
    root.classList.add('is-open');
    clearNotice();
    shopAdd(slug);
    renderOrder();
    title.focus({ preventScroll: true });
    body.scrollTop = 0;
    return true;
  }
  function close() {
    if (root.hidden || !root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('aimco-lock');
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () { root.hidden = true; }, 280);
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target && e.target.closest ? e.target : null;
    var a = t && t.closest('a[data-aim-buy]');
    if (a) { if (open(a.getAttribute('data-aim-buy'), a, 'us')) e.preventDefault(); return; }
    // An EU button: the EU store, when the catalog has one and it sells that product (else the link goes to Aim's EU page)
    a = t && t.closest('a[data-aim-eu]');
    if (!a || !STORES.eu) return;
    var v = a.getAttribute('data-aim-eu'), p = BY_EU[v] || BY_SLUG[v];
    if (!p || !lineIds(p).some(function (id) { return STORES.eu.entry(id); })) return;
    if (open(p.slug, a, 'eu')) e.preventDefault();
  });
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-aimco-close]')) { close(); return; }
    // The checkout link opens Aim's checkout in a new tab; the order and the panel stay. Empty order: no link.
    var go = t.closest('a.aimco-go');
    if (go) { if (!go.hasAttribute('href')) e.preventDefault(); return; }
    var sb = t.closest('.aimco-store button[data-store]');
    if (sb) { setStore(sb.getAttribute('data-store')); clearNotice(); renderOrder(); return; }
    var act = t.closest('[data-act]');
    if (!act || act.disabled) return;
    var a = act.getAttribute('data-act'), i = Number(act.getAttribute('data-i'));
    if (a === 'dec' || a === 'inc') { setQty(i, S.lines[i] ? S.lines[i].qty + (a === 'inc' ? 1 : -1) : 1); renderOrder(); }
    else if (a === 'pick') {
      var pl = S.lines[i];
      pick(i, Number(act.getAttribute('data-v'))); renderOrder();
      // focus: that line's pressed choice (the one clicked; after a merge the line may have moved up)
      var pat = S.lines.indexOf(pl), pk = pat >= 0 && main.querySelector('.aimco-pick button[data-i="' + pat + '"][aria-pressed="true"]');
      if (pk) pk.focus({ preventScroll: true });
    }
    else if (a === 'remove') {
      removeLine(i); renderOrder();
      // focus: the next line's Remove, else the one before, else Add more
      var nx = main.querySelector('[data-fk="rm-' + i + '"]') || main.querySelector('[data-fk="rm-' + (i - 1) + '"]') || main.querySelector('[data-fk="more"]');
      if (nx) nx.focus({ preventScroll: true });
    }
    else if (a === 'more') { S.more = !(S.more || !S.lines.length) || !S.lines.length; renderOrder(); }
    else if (a === 'add') {
      var p = CAT.products.filter(function (x) { return String(x.parent) === act.getAttribute('data-parent'); })[0], id = p && firstFree(p);
      if (!id) return;
      addLine(id); S.more = false; renderOrder();
      var mb = main.querySelector('[data-fk="more"]'); if (mb) mb.focus({ preventScroll: true });
    }
    else if (a === 'addon-add') {
      // an add-on card's Add: its product's first free version (worked out again here, never trusted from the page)
      var e2 = BY_ID[Number(act.getAttribute('data-id'))], ap = e2 && e2.p.kind === 'addon' ? e2.p : null, aid = ap && firstFree(ap);
      if (!aid) return;
      var cardsWas = Array.prototype.slice.call(main.querySelectorAll('.aimco-xcard')), at = cardsWas.indexOf(act.closest('.aimco-xcard'));
      if (!S.lines.length) S.more = true;   // Add more stays as open as it was on the empty order
      addLine(aid); renderOrder();
      // focus: the same card's Add (another version left), else the card now in its place, else the one before, else Add more
      var bs = main.querySelectorAll('.aimco-xadd');
      var nf = main.querySelector('.aimco-xcard[data-parent="' + ap.parent + '"] .aimco-xadd') || bs[at] || bs[at - 1] || main.querySelector('[data-fk="more"]');
      if (nf) nf.focus({ preventScroll: true });
    }
  });
  // A picture that doesn't load (a Files upload missing, say): take it out, so the tile shows plain, and don't ask again
  root.addEventListener('error', function (e) {
    var t = e.target;
    if (!t || t.tagName !== 'IMG' || !main.contains(t)) return;
    BROKEN[t.getAttribute('src')] = true;
    t.parentNode.removeChild(t);
  }, true);
  // On document, not root: when a re-render removes the focused element focus falls to <body>, outside root.
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var list = focusables(panel);
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });

  // A product's price on the page (the Expel Snap Panel band, 2026-10-25): [data-aim-price="<slug>"] shows the
  // catalog's price (kept by the daily price check) in the store the page starts in (the time-zone default, the same
  // test as the page's red button); the US price when that store doesn't sell it. Its own text stays when the panel is
  // off or the slug isn't in the catalog.
  function pagePrices() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-aim-price]'), function (el) {
      var p = BY_SLUG[el.getAttribute('data-aim-price')], id = p && lineIds(p)[0];
      if (!id) return;
      var st = cur().entry(id) ? cur() : STORES.us;
      el.textContent = fmt(st.entry(id).price, st);
    });
  }
  pagePrices();

  window.AimCheckout = { open: function (slug) { return open(slug, null); }, close: close, mode: MODE };
  // Test hooks, on localhost / 127.0.0.1 only (AimCheckout/tests/panel_flow_test.js)
  if (LOCAL) window.AimCheckout._test = {
    esc: esc, catalog: CAT, leave: LEAVE,
    // the Files folder the add-on pictures come from ('' = none: plain tiles)
    files: function () { return FILES; },
    // estimate(lines, store?) and checkoutUrl(lines, store?): store 'us' (default) or 'eu'
    estimate: estimate, checkoutUrl: checkoutUrl,
    // the US store's duties rule: duties() reads it ({percent, flat} or null), duties(block) sets it from a catalog-shaped block (null = none)
    duties: function (d) { if (d !== undefined) { STORES.us.duties = readDuties(d); refresh(); } return STORES.us.duties; },
    // the current order as [[id, qty], ...] (US line ids, in line order)
    order: function () { return orderPairs(); },
    // a line's choice, as its button does: pick(lineIndex, versionId); returns the order
    pick: function (i, id) { pick(i, id); refresh(); return orderPairs(); },
    // the panel's store: store() reads it, store('us' | 'eu') sets it (eu only when the catalog has a good EU block)
    store: function (name) {
      if (name === 'us' || name === 'eu') { setStore(name); refresh(); }
      return S.store;
    },
    // empty the order (and its notice)
    reset: function () { S.lines = []; S.slug = null; S.more = false; clearNotice(); refresh(); },
    // a version's (or simple product's) US price and regular price in the catalog, minor units; regular left as is if omitted
    setPrice: function (id, price, regular) {
      var it = item(id);
      if (!it || !money(price) || (regular != null && !money(regular))) return false;
      it.price = price;
      if (regular != null) it.regular = regular;
      refresh(); pagePrices();
      return true;
    },
    // the catalog's (US) soldOut on a version (or simple product); sold out takes its line off the order with a notice
    setSoldOut: function (id, yes) {
      var it = item(id);
      if (!it) return false;
      it.soldOut = !!yes;
      if (yes && S.store === 'us') soldOut(id);
      refresh();
      return true;
    },
    // a test product (an add-on, say) in the catalog, so a test can prove a new kind needs no other panel change; and out again
    addProduct: function (p) {
      var seen = {};
      CAT.products.forEach(function (x) { seen[x.parent] = seen['s:' + x.slug] = true; x.versions.forEach(function (v) { seen[v.id] = true; }); });
      var n = p && Array.isArray(p.versions) ? p.versions.length : -1, q = cleanProduct(p, seen);
      if (!q || q.versions.length !== n) return false;
      CAT.products.push(q); indexCatalog(); refresh();
      return true;
    },
    removeProduct: function (parent) {
      CAT.products = CAT.products.filter(function (x) { return x.parent !== parent; });
      S.lines = S.lines.filter(function (l) { return BY_ID[l.id] && BY_ID[l.id].p.parent !== parent; });
      indexCatalog();
      if (S.soldSlug && !BY_SLUG[S.soldSlug]) clearNotice();
      refresh();
    }
  };
})();
